import { render } from "./ReceptionTable.vue?vue&type=template&id=791e14c2&scoped=true"
import script from "./ReceptionTable.vue?vue&type=script&lang=js"
export * from "./ReceptionTable.vue?vue&type=script&lang=js"

import "./ReceptionTable.vue?vue&type=style&index=0&id=791e14c2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src141758530/src/mavent-project-vuejs-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791e14c2"]])

export default __exports__